<header class="ac-header">
	<section class="grid grid-980">
		<section class="row justify-content-left">
			<h2 class="col-24 text-16-bold col-padding-override" [innerHTML]="applicationNameText + reportTypeText"></h2>
		</section>
	</section>
</header>

<ng-template #isLoading>
	<div class="grid grid-980">
		<ac-pdf-generate-skeleton></ac-pdf-generate-skeleton>
	</div>
</ng-template>
<div class="generate-report grid grid-980" *ngIf="componentDataMapping$ | async; else isLoading">
	<ng-template [componentId]="'report.config'" let-res [loading]="emptyTemplate">
		<ac-pdf-portfolios-header [data]="res"> </ac-pdf-portfolios-header>
	</ng-template>

	<ng-container *ngIf="isPacApp; else notPacApp">
		<ac-pdf-bpas-report-details
			*ngIf="reportType !== ViewCategory.FA_PLUS_PDF"
			[model]="model"
			[disableReportGeneration]="disableGenerateReport"
			(onFormChange)="onFormChange($event)"
		>
		</ac-pdf-bpas-report-details>
	</ng-container>

	<ng-template #notPacApp>
		<div *ngIf="showAdditionalHeader">
			<div
				class="text-18-bold margin-bottom-10"
				*dcrIfExists="'GENERATE_REPORT_ADDITIONAL_INFO_HEADER'; default: false"
				dcrHTMLKey="GENERATE_REPORT_ADDITIONAL_INFO_HEADER"
			></div>
			<div class="text-16-bold padding-bottom-30 title-with-underline">{{ additionalHeaderInfo }}</div>
		</div>
		<ac-pdf-report-details
			*ngIf="reportType !== ViewCategory.FA_PLUS_PDF"
			[model]="model"
			[firmNameRequired]="firmNameRequired"
			[disableReportGeneration]="disableGenerateReport"
			(onFormChange)="onFormChange($event)"
		>
		</ac-pdf-report-details>
	</ng-template>

	<ac-pdf-logo-upload
		[isLandscape]="isLandscape"
		*showOnlyInView="[ViewCategory.FA_SELF_SERVICE, ViewCategory.PROPOSAL, ViewCategory.SCENARIO_TESTER, ViewCategory.MODELS_BROWSE, ViewCategory.MODELS_EXPERIENCE]"
		[reportCover]="reportCover"
		[showLogoError]="showLogoError"
		(onFileToggle)="onAdvisorLogoToggle($event)"
		(onFileUpdate)="onAdvisorLogoUpdate($event)"
	>
	</ac-pdf-logo-upload>

	<div *ngIf="reportType === ViewCategory.PROPOSAL_PDF">
		<ac-pdf-report-customization
			[reportType]="reportType"
			[mode]="'SNAPSHOT'"
			[showOptionalCol]="false"
			[isBlkModel]="isBlkModel"
			[showPurposeValidation]="showPurposeValidation"
			[showCustomization]="true"
			[achoReportConfiguration]="achoReportConfiguration"
			[componentDataMapping]="componentDataMapping$ | async"
			(onConfigChange)="onSnapshotConfigChange($event)"
			(onConfigToggle)="onSnapshotConfigToggle($event)"
			(onLoadingComplete)="isProposalSnapshotLoadingComplete = $event; onProposalLoadingCompletion()"
		></ac-pdf-report-customization>
	</div>

	<ng-container *ngIf="isCustomizationAvailable">
		<ac-pdf-report-customization
			[reportType]="reportType"
			[isBlkModel]="isBlkModel"
			[achoReportConfiguration]="achoReportConfiguration"
			[componentDataMapping]="componentDataMapping$ | async"
			(onConfigChange)="onConfigChange($event)"
			(onConfigToggle)="onConfigToggle($event)"
			(onLoadingComplete)="isProposalLoadingComplete = $event; onProposalLoadingCompletion()"
		></ac-pdf-report-customization>
	</ng-container>

	<ng-container *ngIf="showRiskProfileModularity">
		<ac-pdf-report-models-filter (onSelectionChange)="setSelectedModelIds($event)"></ac-pdf-report-models-filter>
	</ng-container>

	<ng-container *ngIf="shouldShowStatusFiltering">
		<ac-pdf-fund-filtering (fundStatuesChanged)="onFundStatusChange($event)"> </ac-pdf-fund-filtering>
	</ng-container>

	<ng-container *ngIf="isBenchmarkAvailable">
		<ac-pdf-benchmark-option (includeBenchmarkChange)="onIncludeBenchmarkChange($event)"></ac-pdf-benchmark-option>
	</ng-container>

	<!-- AVOID USING METHOD CALLS, PLS REVIEW AND REMOVE THIS COMMENT/REFACTOR -->
	<ac-pdf-yield-options
		*ngIf="enableYieldOptions"
		[yieldConfig]="yieldConfig"
		[disableYield]="disableYield"
		[showScenarioYield]="showScenarioYield"
		[showEmailLink]="isEmailProspectusRequiredAndValid()"
		[showAllActionsPerformed]="requiredActions"
		[showTooManyActFundsAlert]="disableGenerateReport"
		[showTooManyFundsAlert]="isEmailProspectusInvalid()"
		[showDisabledButtonAlert]="emailNotSentError"
		[hideYield]="hideYield"
		[showPrivacyDisclaimer]="showPrivacyDisclaimer"
		[privacyUrl]="privacyUrl"
		(includeYieldChange)="onIncludeYieldChange($event)"
		(includeScenarioYieldChange)="onIncludeScenarioYieldChange($event)"
		(clientEmailChange)="onSendEmail()"
	>
	</ac-pdf-yield-options>

	<div class="dollar-amount-section" *ngIf="enableDollarAmountToggle">
		<dz-toggle-switch
			[toggleOn]="showDollarAmountAsDefault"
			[toggleLabel]="'Set Dollar Value as Default' | dcr : 'PDF_GENERATE_DOLLAR_AMOUNT_TOGGLE_LABEL'"
			[dcrKeys]="['PDF_GENERATE_DOLLAR_AMOUNT_TOGGLE_LABEL']"
			(click)="showDollarAmountAsDefault = !showDollarAmountAsDefault"
			custom-tracking
			[track-event]="'pdf-generate:include-dollar-amount-toggle:' + (!showDollarAmountAsDefault ? 'on' : 'off')"
		>
		</dz-toggle-switch>
	</div>

	<!-- TODO Waris: move all these classes to shared lib -->
	<section class="margin-vertical-10 warning" *ngIf="performanceErrorMessage">
		<section class="warning-head">
			<icon class="warning-message-icon" type="exclamation-circle"></icon>
		</section>
		<span class="warning-message text-14">{{ performanceErrorMessage }}</span>
	</section>

	<section class="row justify-content-right text-align-right">
		<section class="col-5 cancel">
			<button dz-button color="secondary" (click)="onCancel()" dcrHTMLKey="LABEL_CANCEL">Cancel</button>
		</section>
		<section class="col-5">
			<section *ngIf="!enableActionsDrawer">
				<button
					dz-button
					(click)="generateReport(canGenerateReport)"
					class="no-wrap"
					[ngClass]="{ 'button-disabled-custom': !canGenerateReport }"
					dcrHTMLKey="LABEL_GENERATE"
				>
					Generate Report
				</button>
			</section>
			<section class="actionsDrawer" *ngIf="enableActionsDrawer">
				<button dz-button class="actions" (click)="toggleGenerateDrawer()" [ngClass]="{ 'button-disabled-custom': !canGenerateReport }" dcrHTMLKey="LABEL_GENERATE">
					Generate Report <icon *ngIf="!showGenerateActions" type="chevron-down"></icon> <icon *ngIf="showGenerateActions" type="chevron-up"></icon>
				</button>
				<ac-actions-drawer *ngIf="showGenerateActions">
					<ng-container>
						<ac-actions-drawer-item [text]="'Generate PDF' | dcr : 'GENERATE_AS_PDF'" (click)="generateReport(canGenerateReport)"> </ac-actions-drawer-item>
					</ng-container>
					<ng-container>
						<ac-actions-drawer-item [text]="'Generate as images' | dcr : 'GENERATE_AS_IMAGES'" (click)="generateReportAsImages(canGenerateReport)">
						</ac-actions-drawer-item>
					</ng-container>
				</ac-actions-drawer>
			</section>
		</section>
	</section>

	<pdf-previewer *ngIf="reportPages" (isVisibleChange)="reportPages = null" [pages]="reportPages" [applicationName]="applicationName" [exportAsPNG]="exportAsPNG"></pdf-previewer>

	<section class="disclaimer disclaimer-container" dcrHTMLKey="GENERATE_REPORT_DISCLAIMER">GENERATE_REPORT_DISCLAIMER</section>
	<ng-template #emptyTemplate></ng-template>
</div>
